import PropTypes from "prop-types";
import { StatusBar } from "expo-status-bar";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  KeyboardAvoidingView,
  Picker,
} from "react-native";
import ENV from "app/utils/ENV";
import * as RootNavigation from "app/utils/RootNavigation.js";
import TouchableOpacity from "app/components/TouchableOpacity";
import CheckBox from "app/components/CheckBox";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import Value from "app/components/Value";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import storageActions from "app/utils/storageActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import iconHelpers from "app/utils/iconHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import { styleSheet } from "app/utils/styleSheet";
import Autocomplete from "app/components/Autocomplete";
import DatePicker from "app/components/DatePicker";
import Icon from "app/components/Icon";
import ProgressRing from "app/components/ProgressRing";
import Timeline from "app/components/Timeline";

import { Ionicons, Entypo, Feather } from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class Form extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    value: PropTypes.object.isRequired,
    submitting: PropTypes.bool,
    onChangeValue: PropTypes.func,
    onSubmit: PropTypes.func,
    onSubmitAllRevisions: PropTypes.func,
    fetching: PropTypes.bool,
    ftue: PropTypes.bool,
    showMore: PropTypes.bool,
    expandNotes: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      nameQuery: "",
      parentQuery: "",
      childQuery: "",
      // showMore: props.showMore || false,
      showMore: true,
      fetching: true,
      values: [],
      allValues: [],
      showIconSelector: false,
      showColorSelector: false,
      parents: props.parents || [],
      children: props.children || [],
      errors: [],
      updateAllRevisions: false,
      expandedRevisionIds: [],
      iconQuery: "",
      showInactiveOptions: false,
    };
  }

  async componentDidMount() {
    let { value, id, onChangeValue, ftue } = this.props;
    if (!!value.color && value.color[0] == "#") {
      let color = valueHelpers.hexAsColor(value.color, "");
      onChangeValue("color", color);
    }
    let ids = [];
    // console.log(value.child_ids.join(','))
    // console.log(data)

    // let values = await apiActions.request('values', 'GET', data)
    // if(!!value.parent_ids) ids = [...ids, ...value.parent_ids.join(',')]
    // if(!!value.child_ids) ids = [...ids, ...value.child_ids.join(',')]
    // let data = {lite: true, only_ids: ids}

    let allValues = await storageActions.fetchItem("values", []);
    // if(ftue) allValues = ftueHelpers.ftueValues().filter(v => typeof v.id == 'number')
    // allValues = allValues.filter(v => typeof v.id == 'number')

    let values = [];
    // let values = await valueActions.autocompleteValues(allValues);
    // values = values.filter((v) => typeof v.id == "number");
    // console.log(allValues)

    let parents = this.props.parents || valueHelpers.getParents({ value });
    let children = this.props.children || valueHelpers.getChildren({ value });
    if (!!this.props.childIds?.length) {
      let extraChildren = values.filter((v) =>
        this.props.childIds.includes(v.id),
      );
      children = [...children, ...extraChildren];
    }
    this.setState({ values, allValues, parents, children, fetching: false });
  }

  render() {
    let {
      value,
      submitting,
      onChangeValue,
      onSubmit,
      onDelete,
      onSubmitAllRevisions,
      ftue,
      expandNotes,
      revising,
    } = this.props;
    let {
      parentQuery,
      childQuery,
      nameQuery,
      showMore,
      values,
      allValues,
      showIconSelector,
      showColorSelector,
      fetching,
      parents,
      children,
      errors,
      updateAllRevisions,
      expandedRevisionIds,
      iconQuery,
      showInactiveOptions,
    } = this.state;

    let parentColor = valueHelpers.getColor(
      { ...value, parentColors: parents.map((p) => p.color) },
      "parentColors",
    );
    let bgColor =
      !!value.color && !!parentColor
        ? colorHelpers.averageColor([
            parentColor,
            valueHelpers.colorAsHex(value.color),
          ])
        : parentColor ||
          (!!value.color && valueHelpers.colorAsHex(value.color));
    bgColor = colorHelpers.averageColor([bgColor, this.context.colors.empty]);
    let valColor = valueHelpers.getColor(value);

    let iconColor = !!value.color
      ? valueHelpers.colorAsHex(value.color)
      : this.context.colors.foreground;
    let { color, opacity } = valueHelpers.iconColor(value, valColor);
    let darkenedColor = colorHelpers.modifyHex(iconColor, 0.2);
    let inputBgColor = colorHelpers.hexToRgbaString(darkenedColor, 0.6);

    // let placeholderColor = colorHelpers.rgbaAsFloat(darkenedColor) < 0.25 ? this.context.colors.placeholder : this.context.colors.lightPlaceholder
    let placeholderColor = `rgba(200,200,200,0.5)`;

    let inputStyle = {
      // ...this.styles().input,
      ...styleSheet.input,
      backgroundColor: inputBgColor,
      // borderWidth: 1, borderColor: 'white',
      color: this.context.colors.lightForeground,
      padding: this.context.sizes.large,
    };

    let descendantIds = valueHelpers.descendantIds(value, values);
    let ancestorIds = valueHelpers.ancestorIds(value, values);
    let parentSuggestions = textHelpers.suggestions(
      parentQuery,
      values.filter((v) => !descendantIds.includes(v.id)),
    );
    parentSuggestions = parentSuggestions.filter(
      (v) => typeof v.id != "string" && v.id != 1,
    );
    if (!showInactiveOptions)
      parentSuggestions = valueHelpers.filterToActive({
        values: parentSuggestions,
        removeHidden: false,
        removeSubTasks: false,
      });
    if (!!parentQuery?.length && !parentSuggestions?.length) {
      parentSuggestions = [
        {
          id: 0,
          text: `no matches found.${showInactiveOptions ? "" : " show more?"}`,
          style: { color: placeholderColor },
        },
        { id: "create", text: `create`, style: { color: placeholderColor } },
      ];
    }
    let childSuggestions = textHelpers.suggestions(
      childQuery,
      values.filter((v) => !ancestorIds.includes(v.id)),
    );
    childSuggestions = childSuggestions.filter(
      (v) => typeof v.id != "string" && v.id != 1,
    );
    if (!showInactiveOptions)
      childSuggestions = valueHelpers.filterToActive({
        values: childSuggestions,
        removeHidden: false,
        removeSubTasks: false,
      });
    if (!!childQuery?.length && !childSuggestions?.length) {
      childSuggestions = [
        {
          id: 0,
          text: `no matches found.${showInactiveOptions ? "" : " show more?"}`,
          style: { color: placeholderColor },
        },
        { id: "create", text: `create`, style: { color: placeholderColor } },
      ];
    }
    let titleSuggestions = [];
    if (ftue) {
      let titleSuggestionValues = allValues.filter(
        (v) => typeof v.id == "string" && !v.text.includes("Create a custom"),
      );
      titleSuggestions = textHelpers.suggestions(
        nameQuery,
        titleSuggestionValues,
      );
    }

    let note =
      value.notes?.find((n) => typeof n == "string" && n?.startsWith(`7:`)) ||
      "";
    // note = note.split(/:(.+)/)[1]
    note = note.substr(2);

    return (
      <KeyboardAvoidingView
        enabled
        behavior={"padding"}
        keyboardShouldPersistTaps={"handled"}
        style={this.styles().wrapper}
        // keyboardVerticalOffset={isIphoneX() ? (fontVars.landingHeaderSize + 20) : fontVars.landingHeaderSize + Math.max(0, (Constants.statusBarHeight-20))}
        keyboardVerticalOffset={60}
      >
        {/*<View style={[this.styles().wrapper]}>*/}

        <View
          style={{
            ...StyleSheet.absoluteFillObject,
            // backgroundColor: this.context.colors.darkest
          }}
        >
          <View
            style={{
              ...StyleSheet.absoluteFillObject,
              backgroundColor: bgColor || undefined,
              // opacity: ENV.DARK ? 0.3 : 0.75,
            }}
          />
        </View>
        <ScrollView
          style={{ flex: 1 }}
          // contentContainerStyle={{
          //   flex: 1,
          // }}
        >
          {(fetching || this.props.fetching) && <ActivityIndicator />}

          {!!value.id && (
            <View
              style={[
                this.styles().row,
                this.styles().label,
                { marginBottom: 0 },
              ]}
            >
              <Text style={{ fontSize: this.context.sizes.large }}>
                {revising ? "Revise" : "Update"} Value {value.id}
              </Text>
              {/*<Text 
              style={[styleSheet.icon, {marginLeft: this.context.sizes.base}]} 
              onPress={() => onChangeValue('id', null)}
            >
              X
            </Text>*/}
              <Text
                underline
                // style={[{marginLeft: this.context.sizes.base}]}
                onPress={onDelete}
              >
                delete
              </Text>
            </View>
          )}

          {/*revising && <Text style={this.styles().label}>Completion Achievement</Text>}
          {revising && (
            <TextInput
              style={[inputStyle]}
              placeholderTextColor={placeholderColor}
              value={value.achievement}
              placeholder={"Achievement"}
              onChangeText={(val) => onChangeValue("achievement", val)}
            />
          )*/}

          <View style={[this.styles().row, { marginBottom: 0 }]}>
            <View style={{ flex: 1 }}>
              <Text style={this.styles().label}>Title</Text>
              <TextInput
                style={[inputStyle]}
                placeholderTextColor={placeholderColor}
                value={value.title}
                placeholder={"Value Title"}
                onChangeText={(val) => onChangeValue("title", val)}
                autoFocus
              />
            </View>

            <View
              style={{
                //   flexDirection: "row",
                alignItems: "center",
                // borderWidth: 3,
              }}
            >
              <Text
                center
                style={[this.styles().label]}
                onPress={() => {
                  onChangeValue("is_note", !value.is_note);
                }}
              >
                Note
              </Text>
              <CheckBox
                style={{ marginRight: this.context.sizes.base }}
                color={color}
                value={value.is_note}
                onValueChange={(val) => {
                  onChangeValue("is_note", val);
                }}
              />
              {/*<Text
                // style={[this.styles().label]}
                onPress={() => {
                  onChangeValue("is_note", !value.is_note);
                }}
              >
                Note
              </Text>*/}
            </View>
          </View>

          <View style={[this.styles().row, { marginBottom: 0, alignItems: "center" }]}>
            <Text style={this.styles().label}>Category</Text>
            <View style={{ flex: 1, borderWidth: 1, borderColor: this.context.colors.trim, borderRadius: 4, marginHorizontal: this.context.sizes.large }}>
              <Picker
                selectedValue={value.category || ""}
                style={{ color: this.context.colors.lightForeground, backgroundColor: "transparent" }}
                onValueChange={(itemValue) => onChangeValue("category", itemValue || null)}
              >
                <Picker.Item label="— none —" value="" />
                <Picker.Item label="topic" value="topic" />
                <Picker.Item label="project" value="project" />
                <Picker.Item label="event" value="event" />
                <Picker.Item label="note" value="note" />
                <Picker.Item label="tarot" value="tarot" />
                <Picker.Item label="narration" value="narration" />
              </Picker>
            </View>
          </View>

          <View style={[this.styles().row, { marginBottom: 0 }]}>
            <View style={{ flex: 1 }}>
              <Text style={this.styles().label}>Text</Text>
              <TextInput
                style={[inputStyle, { minHeight: 100 }]}
                placeholderTextColor={placeholderColor}
                value={value.text}
                placeholder={"Value Content"}
                onChangeText={(val) => onChangeValue("text", val)}
                multiline={true}
                autoHeight={true}
                autoFocus
              />
            </View>
          </View>

          {/*<Autocomplete
            placeholder={"value name"}
            placeholderTextColor={placeholderColor}
            extraStyle={inputStyle}
            // onFocus={() => this.setState({focusedField: 'name'})}
            // data={focusedField == 'name' ? suggestions : []}
            // defaultValue={value.name || ''}
            query={value.text || ""}
            data={titleSuggestions}
            onChangeText={(text) => {
              this.setState({ nameQuery: text });
              onChangeValue("text", text);
            }}
            renderItem={({ item, i }) => (
              <TouchableOpacity key={i} onPress={() => this.selectValue(item)}>
                <Text>{item.text}</Text>
              </TouchableOpacity>
            )}
          />*/}

          {/*!revising && <Text style={this.styles().label}>Achievement</Text>*/}
          {/*!revising && (
            <TextInput
              style={[inputStyle]}
              placeholderTextColor={placeholderColor}
              value={value.achievement}
              placeholder={"Achievement"}
              onChangeText={(val) => onChangeValue("achievement", val)}
            />
          )*/}

          <View
            style={[
              this.styles().row,
              {
                flexDirection: "column",
                alignItems: "stretch",
                marginBottom: 0,
              },
            ]}
          >
            <View style={[this.styles().row, { marginBottom: 0 }]}>
              <View>
                <Text style={this.styles().label}>Icon</Text>
                <View style={this.styles().iconWrapper}>
                  <View
                    style={{
                      position: "absolute",
                      top: this.context.sizes.small,
                      left: this.context.sizes.small,
                    }}
                    pointerEvents="none"
                  >
                    {value.is_note ? (
                      <View
                        style={{
                          marginTop: this.context.sizes.small,
                          marginLeft: this.context.sizes.small,
                          width: this.context.sizes.giant * 1.5,
                          height: this.context.sizes.giant * 1.5,
                          borderRadius: this.context.sizes.smallBorderRadius,
                          borderWidth: 3,
                          borderColor:
                            valueHelpers.colorAsHex(value.color) ||
                            this.context.colors.trim,
                        }}
                      />
                    ) : (
                      <ProgressRing
                        value={{ cycle: value.cycle }}
                        size={this.context.sizes.giant * 1.35}
                        emptyColor={
                          iconColor
                          // valueHelpers.colorAsHex(value.color) || this.context.colors.trim
                        }
                        selected
                      />
                    )}
                  </View>
                  <Icon
                    onPress={() =>
                      this.setState({
                        showIconSelector: !showIconSelector,
                        showColorSelector: false,
                      })
                    }
                    name={value.icon || "none"}
                    color={color}
                    size={this.context.sizes.giant}
                  />
                </View>
                <Text>icon:{value.icon}</Text>
                <Text>inherited:{value.inherited_icon}</Text>
              </View>

              <View>
                <Text style={this.styles().label}>Color</Text>
                <TouchableOpacity
                  onPress={() =>
                    this.setState({
                      showColorSelector: !showColorSelector,
                      showIconSelector: false,
                    })
                  }
                  style={this.styles().iconWrapper}
                >
                  <View
                    style={[
                      this.styles().largeColorDot,
                      {
                        backgroundColor: valueHelpers.colorAsHex(value.color),
                        borderWidth: !!value.color ? 0 : 3,
                        borderColor: this.context.colors.foreground,
                      },
                    ]}
                  />
                </TouchableOpacity>
                <Text>color:{value.color}</Text>
                <Text>inherited:{value.inherited_color}</Text>
              </View>

              <View>
                <Text style={this.styles().label}>Frequency</Text>
                <TextInput
                  style={[inputStyle]}
                  placeholderTextColor={placeholderColor}
                  value={value.frequency}
                  placeholder={"frequency"}
                  onChangeText={(val) => onChangeValue("frequency", val)}
                />
              </View>

              <View>
                <Text style={this.styles().label}>Quota</Text>
                <TextInput
                  style={[inputStyle]}
                  placeholderTextColor={placeholderColor}
                  placeholder={"#"}
                  onChangeText={(val) => onChangeValue("cycle", val)}
                  // disabled={value.is_note}
                  // value={value.is_note ? "-" : (value.cycle || 7).toString()}
                  value={(value.cycle || "").toString()}
                  value={value.cycle}
                />
              </View>
            </View>
          </View>

          {showIconSelector && (
            <View style={{ paddingHorizontal: this.context.sizes.large }}>
              <TextInput
                style={[inputStyle]}
                placeholderTextColor={placeholderColor}
                value={iconQuery}
                placeholder={"search..."}
                onChangeText={(iconQuery) => this.setState({ iconQuery })}
              />
              <View style={this.styles().selectorRow}>
                {iconHelpers
                  .iconOptions()
                  .filter((icn) =>
                    !iconQuery?.length
                      ? true
                      : icn.toLowerCase().includes(iconQuery.toLowerCase()),
                  )
                  .map((icn, i) => (
                    <TouchableOpacity
                      key={i}
                      style={this.styles().selectable}
                      onPress={() => {
                        onChangeValue(
                          "icon",
                          ["select", "none", "", null].includes(icn)
                            ? null
                            : icn,
                        );
                        this.setState({ showIconSelector: false });
                      }}
                    >
                      <Icon name={icn} color={color} />
                    </TouchableOpacity>
                  ))}
              </View>
              {(!!parents?.length || true) && (
                <Text italic>
                  leave icon blank to inherit from closest parent
                </Text>
              )}
            </View>
          )}

          {showColorSelector && (
            <View style={{ paddingHorizontal: this.context.sizes.large }}>
              <View style={this.styles().selectorRow}>
                {valueHelpers.colorOptions().map((c, i) => (
                  <TouchableOpacity
                    key={i}
                    style={this.styles().selectable}
                    onPress={() => {
                      onChangeValue("color", c);
                      this.setState({ showColorSelector: false });
                    }}
                  >
                    <View
                      style={[
                        this.styles().colorDot,
                        { backgroundColor: valueHelpers.colorAsHex(c) },
                      ]}
                    />
                  </TouchableOpacity>
                ))}
                <TouchableOpacity
                  style={this.styles().selectable}
                  onPress={() => {
                    onChangeValue("color", null);
                    this.setState({ showColorSelector: false });
                  }}
                >
                  <View style={[this.styles().colorDot]} />
                </TouchableOpacity>
              </View>
              {(!!parents?.length || true) && (
                <Text italic>leave color blank to inherit from ancestors</Text>
              )}
            </View>
          )}

          <View
            style={{
              alignSelf: "stretch",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Text style={this.styles().label}>Parent Values</Text>
            <Text
              underline
              style={this.styles().label}
              onPress={() => {
                RootNavigation.push("Create", {
                  parent_ids: value.parent_ids,
                  children: [value],
                  intermediary: true,
                });
              }}
            >
              Create Intermediary
            </Text>
          </View>
          <ScrollView
            horiztonal
            style={{ flexGrow: 0 }}
            contentContainerStyle={{ flexDirection: "row" }}
          >
            {parents.map((v, i) => (
              <Value
                key={i}
                value={v}
                hideRing
                style={{ height: "auto" }}
                onPress={async () => {
                  let confirm = await valueActions.confirm(
                    "confirm",
                    "",
                    "Remove relationship?",
                    ftue
                      ? `An item's level is determined by it's relationships.`
                      : "",
                  );
                  if (!confirm) return;
                  this.selectParent(v);
                }}
              />
            ))}
          </ScrollView>
          <Autocomplete
            // extraStyle={{marginLeft: this.context.sizes.large}}
            inputStyle={inputStyle}
            placeholder={"search to add parents"}
            onBlur={() => {
              //if(!parentSuggestions[0]?.id)
              //this.setState({parentQuery: ''})
            }}
            placeholderTextColor={placeholderColor}
            query={parentQuery || ""}
            data={parentSuggestions}
            onChangeText={(text) => this.setState({ parentQuery: text })}
            renderItem={({ item, i }) => (
              <TouchableOpacity key={i} onPress={() => this.selectParent(item)}>
                <Text
                  style={[item.style, { padding: this.context.sizes.small }]}
                >
                  • {item.title}
                  {value.parent_ids.includes(item.id) ? " ✓" : null}
                </Text>
              </TouchableOpacity>
            )}
          />

          <Text style={this.styles().label}>Child Tasks</Text>
          <ScrollView
            horiztonal
            style={{ flexGrow: 0 }}
            contentContainerStyle={{ flexDirection: "row" }}
          >
            {children.map((v, i) => (
              <Value
                key={i}
                value={v}
                hideRing
                style={{ height: "auto" }}
                onPress={async () => {
                  let confirm = await valueActions.confirm(
                    "confirm",
                    "",
                    "Remove relationship?",
                    ftue
                      ? `An item's level is determined by it's relationships. With no children, this value will be on the bottom level.`
                      : "",
                  );
                  if (!confirm) return;
                  this.selectChild(v);
                }}
                onLongPress={async () => {
                  let confirm = await valueActions.confirm(
                    "confirm",
                    "",
                    "Copy color and icon from child?",
                    "",
                  );
                  if (!confirm) return;
                  onChangeValue("color", v.color);
                  onChangeValue("icon", v.icon);
                }}
              />
            ))}
          </ScrollView>
          <Autocomplete
            // extraStyle={{marginLeft: this.context.sizes.large}}
            inputStyle={inputStyle}
            placeholder={"search to add children"}
            onBlur={() => {
              //if(!childSuggestions[0]?.id)
              //this.setState({childQuery: ''})
            }}
            placeholderTextColor={placeholderColor}
            query={childQuery || ""}
            data={childSuggestions}
            onChangeText={(text) => {
              // console.log(text, textHelpers.suggestions(childQuery, values))
              this.setState({ childQuery: text });
            }}
            renderItem={({ item, i }) => (
              <TouchableOpacity key={i} onPress={() => this.selectChild(item)}>
                <Text
                  style={[item.style, { padding: this.context.sizes.small }]}
                >
                  {item.text}
                  {children.map((c) => c.id).includes(item.id) ? " ✓" : null}
                </Text>
              </TouchableOpacity>
            )}
          />

          {/*<Text style={this.styles().label}>Tier</Text>
          <Picker
            selectedValue={value.tier}
            style={[inputStyle]}
            placeholderTextColor={placeholderColor}
            placeholder={"tier"}
            onValueChange={(itemValue, itemIndex) =>
              onChangeValue("tier", itemValue)
            }
          >
            <Picker.Item label="-" value={null} />
            <Picker.Item label="Strategic" value={3} />
            <Picker.Item label="Intermediate" value={2} />
            <Picker.Item label="Tactical" value={1} />
          </Picker>*/}

          {!showMore && !ftue && (
            // {!showMore && (
            <Text
              onPress={() => this.setState({ showMore: true })}
              style={[
                this.styles().label,
                { paddingBottom: this.context.sizes.giant },
              ]}
            >
              Show more
            </Text>
          )}
          {showMore && (
            <View style={{ zIndex: 1 }}>
              {/*<Text style={this.styles().label}>Snooze Until</Text>
              <DatePicker
                inputStyle={{ ...inputStyle, zIndex: 3 }}
                placeholderTextColor={placeholderColor}
                selected={
                  !!value.snooze_until ? new Date(value.snooze_until) : null
                }
                value={
                  !!value.snooze_until ? new Date(value.snooze_until) : null
                }
                onChange={(val) => onChangeValue("snooze_until", val)}
                showTimeSelect
              />
              {!!value.snooze_until && (
                <Text
                  italic
                  underline
                  style={[{ padding: this.context.sizes.large }]}
                  onPress={() => onChangeValue("snooze_until", null)}
                >
                  remove snooze
                </Text>
              )*/}

              {/*<Text style={this.styles().label}>
                <CheckBox
                  // style={this.styles().label}
                  value={value.completed}
                  onValueChange={(val) => {
                    onChangeValue("completed", val);
                    if (!value.completed_at) {
                      onChangeValue("completed_at", new Date());
                    }
                  }}
                />{" "}
                Completed
              </Text>*/}

              <View style={[this.styles().row, { zIndex: 2 }]}>
                <View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text style={this.styles().label}>Completed At</Text>
                    {!!value.completed_at && (
                      <Feather
                        name="x"
                        onPress={() => {
                          onChangeValue("completed_at", null);
                          onChangeValue("completed", false);
                        }}
                        color={this.context.colors.lightForeground}
                        style={[
                          styleSheet.bullet,
                          // styleSheet.mobileMediumBullet,
                          // { borderColor: valueColor },
                          { borderColor: this.context.colors.lightForeground },
                          { zIndex: 3 },
                          { backgroundColor: "transparent" },
                        ]}
                      />
                    )}
                  </View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <View style={{ flex: 1 }}>
                      <DatePicker
                        inputStyle={{ ...inputStyle, zIndex: 2 }}
                        placeholderTextColor={placeholderColor}
                        selected={
                          !!value.completed_at
                            ? new Date(value.completed_at)
                            : undefined
                        }
                        value={
                          !!value.completed_at
                            ? new Date(value.completed_at)
                            : undefined
                        }
                        onChange={(val) => {
                          onChangeValue("completed_at", val);
                          onChangeValue("completed", true);
                        }}
                        showTimeSelect
                      />
                    </View>
                    {/*!!value.completed_at && (
                      <Feather
                        name="x"
                        onPress={() => {
                          onChangeValue("completed_at", null);
                          onChangeValue("completed", false);
                        }}
                        color={this.context.colors.lightForeground}
                        style={[
                          styleSheet.bullet,
                          styleSheet.mobileMediumBullet,
                          // { borderColor: valueColor },
                          { borderColor: this.context.colors.lightForeground },
                          { zIndex: 3 },
                          { backgroundColor: "transparent" },
                        ]}
                      />
                    )*/}
                  </View>
                </View>

                <View>
                  <Text style={this.styles().label}>Created At</Text>
                  <DatePicker
                    inputStyle={{ ...inputStyle, zIndex: 1 }}
                    placeholderTextColor={placeholderColor}
                    selected={
                      !!value.created_at
                        ? new Date(value.created_at)
                        : new Date()
                    }
                    value={
                      !!value.created_at
                        ? new Date(value.created_at)
                        : new Date()
                    }
                    onChange={(val) => onChangeValue("created_at", val)}
                    showTimeSelect
                  />
                </View>

                <View>
                  <Text style={this.styles().label}>Updated At</Text>
                  <DatePicker
                    inputStyle={{ ...inputStyle, zIndex: 1 }}
                    placeholderTextColor={placeholderColor}
                    selected={
                      !!value.updated_at
                        ? new Date(value.updated_at)
                        : new Date()
                    }
                    value={
                      !!value.updated_at
                        ? new Date(value.updated_at)
                        : new Date()
                    }
                    onChange={(val) => onChangeValue("updated_at", val)}
                    showTimeSelect
                  />
                </View>

                <View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text style={this.styles().label}>Archived At</Text>
                    {!!value.archived_at && (
                      <Feather
                        name="x"
                        onPress={() => {
                          onChangeValue("archived_at", null);
                        }}
                        color={this.context.colors.lightForeground}
                        style={[
                          styleSheet.bullet,
                          { borderColor: this.context.colors.lightForeground },
                          { zIndex: 3 },
                          { backgroundColor: "transparent" },
                        ]}
                      />
                    )}
                  </View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <View style={{ flex: 1 }}>
                      <DatePicker
                        inputStyle={{ ...inputStyle, zIndex: 2 }}
                        placeholderTextColor={placeholderColor}
                        selected={
                          !!value.archived_at
                            ? new Date(value.archived_at)
                            : undefined
                        }
                        value={
                          !!value.archived_at
                            ? new Date(value.archived_at)
                            : undefined
                        }
                        onChange={(val) => {
                          onChangeValue("archived_at", val);
                        }}
                        showTimeSelect
                      />
                    </View>
                  </View>
                </View>
              </View>

              <View style={[this.styles().row, { zIndex: 2 }]}>
                <View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text style={this.styles().label}>Start At</Text>
                    {!!value.start_at && (
                      <Feather
                        name="x"
                        onPress={() => {
                          onChangeValue("start_at", null);
                        }}
                        color={this.context.colors.lightForeground}
                        style={[
                          styleSheet.bullet,
                          { borderColor: this.context.colors.lightForeground },
                          { zIndex: 3 },
                          { backgroundColor: "transparent" },
                        ]}
                      />
                    )}
                  </View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <View style={{ flex: 1 }}>
                      <DatePicker
                        inputStyle={{ ...inputStyle, zIndex: 2 }}
                        placeholderTextColor={placeholderColor}
                        selected={
                          !!value.start_at
                            ? new Date(value.start_at)
                            : undefined
                        }
                        value={
                          !!value.start_at
                            ? new Date(value.start_at)
                            : undefined
                        }
                        onChange={(val) => {
                          onChangeValue("start_at", val);
                        }}
                        showTimeSelect
                      />
                    </View>
                  </View>
                </View>

                <View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text style={this.styles().label}>End At</Text>
                    {!!value.end_at && (
                      <Feather
                        name="x"
                        onPress={() => {
                          onChangeValue("end_at", null);
                        }}
                        color={this.context.colors.lightForeground}
                        style={[
                          styleSheet.bullet,
                          { borderColor: this.context.colors.lightForeground },
                          { zIndex: 3 },
                          { backgroundColor: "transparent" },
                        ]}
                      />
                    )}
                  </View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <View style={{ flex: 1 }}>
                      <DatePicker
                        inputStyle={{ ...inputStyle, zIndex: 2 }}
                        placeholderTextColor={placeholderColor}
                        selected={
                          !!value.end_at ? new Date(value.end_at) : undefined
                        }
                        value={
                          !!value.end_at ? new Date(value.end_at) : undefined
                        }
                        onChange={(val) => {
                          onChangeValue("end_at", val);
                        }}
                        showTimeSelect
                      />
                    </View>
                  </View>
                </View>

                <View />
                <View />
              </View>

              {/*<Text style={this.styles().label}>Note</Text>
              <TextInput
                multiline
                style={[inputStyle, { minHeight: 300 }]}
                placeholderTextColor={placeholderColor}
                value={note}
                placeholder={"free-write on the current state of this item"}
                // onChangeText={(created_at) => onChangeValue('created_at', created_at)}
                onChangeText={(val) => this.onChangeNotes(7, val)}
                onKeyPress={(event) => {
                  // console.log('keypress:', event.keyCode)
                  // if (event.keyCode == 27){
                  //   if(this.props.onCancel) this.props.onCancel()
                  //   return
                  // }
                  // if (event.keyCode == 13){
                  //   if(this.props.onSubmit) this.props.onSubmit()
                  //   return
                  // }
                }}
              />*/}

              {/*<Text style={this.styles().label}>Timeline</Text>
              <Timeline value={value} expandNotes={expandNotes} />
              {textHelpers
                .newestFirst(value.revisions, "created_at")
                .map((v, i) => {
                  return (
                    <View>
                      <TouchableOpacity
                        style={{ flexDirection: "row", alignItems: "center" }}
                        onPress={() => {
                          if (expandedRevisionIds.includes(v.id))
                            expandedRevisionIds.splice(
                              expandedRevisionIds.indexOf(v.id),
                              1
                            );
                          else expandedRevisionIds.push(v.id);
                          this.setState({ expandedRevisionIds });
                        }}
                      >
                        <Text
                          style={[this.styles().label, { paddingBottom: undefined }]}
                        >
                          {value.revisions.length - 1 - i}: {v.text}
                        </Text>
                        <Feather
                          name={
                            expandedRevisionIds.includes(v.id)
                              ? "chevron-up"
                              : "chevron-down"
                          }
                          color={this.context.colors.foreground}
                          size={this.context.sizes.smallItemHeight}
                        />
                      </TouchableOpacity>

                      {expandedRevisionIds.includes(v.id) && (
                        <Timeline value={v} expandNotes={expandNotes} />
                      )}
                    </View>
                  );
                })*/}

              {/*<Text style={this.styles().label}>Progress at</Text>
            <TextInput
              style={inputStyle}
              placeholderTextColor={placeholderColor}
              value={value.progress_at || ''}
              placeholder={'checks at (comma separated)'}
              onChangeText={(checks_at) => onChangeValue('checks_at', checks_at ? checks_at.split(',') : [])}
            />*/}
            </View>
          )}

          {!!errors?.length && (
            <View>
              {errors.map((e, i) => (
                <Text style={[this.styles().label, { color: "red" }]}>
                  • {e}
                </Text>
              ))}
            </View>
          )}

          {/*!!onSubmitAllRevisions && (
          <TouchableOpacity 
            onPress={() => this.setState({updateAllRevisions: !updateAllRevisions})} 
            style={[
              this.styles().buttonWrapper,
              {
                backgroundColor: inputBgColor,
                // backgroundColor: 'transparent',
                borderColor: iconColor,
                borderTopWidth: 2,
                // borderBottomWidth: 2,
              },
            ]}
          >
            <Text style={[this.styles().buttonText]}>
              Update all revisions
            </Text>
            <Feather name={updateAllRevisions ? 'check-circle' : 'circle'} style={[this.styles().buttonIcon, {marginLeft: this.context.sizes.base}]} />
          </TouchableOpacity>
        )*/}

          <View
            style={{
              flexGrow: 1,
              justifyContent: "flex-end",
              alignSelf: "stretch",
            }}
          >
            <TouchableOpacity
              onPress={this.validate() ? this.onSubmit : this.showErrors}
              disabled={submitting}
              style={[
                this.styles().buttonWrapper,
                // !this.validate()
                //   ? this.styles().disabledButtonWrapper
                //   :
                {
                  backgroundColor: darkenedColor,
                  borderColor: iconColor,
                  borderTopWidth: 2,
                  borderBottomWidth: 2,
                },
                !!onSubmitAllRevisions ? { marginTop: 0 } : null,
              ]}
            >
              <Text
                bold
                style={[
                  this.styles().buttonText,
                  !this.validate() ? this.styles().disabledButtonText : null,
                ]}
              >
                Submit
              </Text>
              {submitting ? (
                <ActivityIndicator
                  color={this.context.colors.lightForeground}
                  style={this.styles().buttonIcon}
                />
              ) : (
                <Entypo
                  name={"chevron-right"}
                  style={[
                    this.styles().buttonIcon,
                    !this.validate() ? this.styles().disabledButtonText : null,
                  ]}
                />
              )}
            </TouchableOpacity>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    );
  }

  onChangeNotes = (index, note) => {
    let { onChangeValue, value } = this.props;
    let notes = value.notes || [];
    let noteString = `${index}:${note}`;
    let noteIndex = notes.findIndex(
      (n) => typeof n == "string" && n?.startsWith(`${index}:`),
    );
    if (noteIndex < 0) {
      notes.push(noteString);
    } else {
      notes[noteIndex] = noteString;
    }
    console.log(notes);
    onChangeValue("notes", notes);
  };

  validate = () => {
    let { value, submitting, onChangeValue } = this.props;
    let valid = true;
    if (submitting) valid = false;
    else if (!value?.text?.length && !value?.title?.length) valid = false;
    // else if(!!!value.color && !value.parent_ids?.length) valid = false
    // else if(!!!value.icon && !value.parent_ids?.length) valid = false
    return valid;
  };

  showErrors = () => {
    let { value } = this.props;
    let errors = [];
    if (!value.title?.length && !value.text?.length)
      errors.push("All values require a name");
    // if(!!!value.icon && !value.parent_ids?.length)
    //   errors.push('Top-level values require an icon')
    // if(!!!value.color && !value.parent_ids?.length)
    //   errors.push('Top-level values require a color')
    this.setState({ errors });
  };

  showWarnings = async () => {
    console.warn("finished warnings");
    let { value } = this.props;
    let { updateAllRevisions } = this.state;
    let confirm = true;
    if (!!!value.icon && !value.parent_ids?.length) {
      confirm = await valueActions.confirm(
        "confirm",
        "",
        "Are you sure?",
        `This item has no icon of its own and no parents to inherit from`,
      );
      if (!confirm) return false;
    }
    if (!!!value.color && !value.parent_ids?.length) {
      confirm = await valueActions.confirm(
        "confirm",
        "",
        "Are you sure?",
        `This item has no color of its own and no parents to inherit from`,
      );
      if (!confirm) return false;
    }
    if (updateAllRevisions) {
      confirm = await valueActions.confirm(
        "confirm",
        "",
        "Are you sure?",
        `Changes to color, icon, and relationships will be applied to all previous revisions`,
      );
      if (!confirm) return false;
    }
    return true;
  };

  onSubmit = async () => {
    console.log("on submit...");
    let { onSubmit, onSubmitAllRevisions } = this.props;
    let { updateAllRevisions } = this.state;
    let confirm = await this.showWarnings();
    console.warn("finished warnings");
    if (!confirm) return;
    if (updateAllRevisions && !!onSubmitAllRevisions) {
      // onSubmitAllRevisions()
      alert("disabled update all revisions");
    } else {
      onSubmit();
    }
  };

  selectParent = (parent) => {
    if (!parent?.id) {
      this.setState({ showInactiveOptions: true });
      return;
    }
    if (parent?.id == "create") {
      alert("create");
      return;
    }
    let { value, onChangeValue } = this.props;
    let { allValues } = this.state;
    let { parents } = this.state;
    let parent_ids = value.parent_ids;
    if (parent_ids.includes(parent.id)) {
      parent_ids.splice(parent_ids.indexOf(parent.id), 1);
      parents.splice(
        parents.findIndex((v) => v.id == parent.id),
        1,
      );
    } else {
      parent_ids.push(parent.id);
      // parents.push(allValues.find((v) => v.id == parent.id));
      parents.push(parent);
    }
    onChangeValue("parent_ids", parent_ids);
    this.setState({ parentQuery: "", parents, showInactiveOptions: false });
  };

  selectChild = (child) => {
    if (!child?.id) {
      this.setState({ showInactiveOptions: true });
      return;
    }
    if (child?.id == "create") {
      alert("create");
      return;
    }
    let { value, onChangeValue } = this.props;
    let { allValues } = this.state;
    let { children } = this.state;
    let child_ids = children.map((c) => c.id);
    if (child_ids.includes(child.id)) {
      child_ids.splice(child_ids.indexOf(child.id), 1);
      children.splice(
        children.findIndex((v) => v.id == child.id),
        1,
      );
    } else {
      child_ids.push(child.id);
      children.push(allValues.find((v) => v.id == child.id));
      children.push(child);
    }
    onChangeValue("child_ids", child_ids);
    this.setState({ childQuery: "", children, showInactiveOptions: false });
  };

  selectValue = (v) => {
    let { value, onChangeValue } = this.props;
    this.setState({ nameQuery: "" });
    // this.props.onChangeValue('value', v)
    onChangeValue("text", v.text);
    console.log(!!v.color, v);
    if (!value.color && !!v.color) onChangeValue("color", v.color);
    if (!value.icon && !!v.icon) onChangeValue("icon", v.icon);
  };

  styles = () => ({
    wrapper: {
      // backgroundColor: '#222',
      flex: 1,
      alignItems: "stretch",
      justifyContent: "flex-start",
      // padding: this.context.sizes.base,
    },
    section: {
      marginTop: 20,
    },
    title: {
      borderBottomWidth: 1,
      borderBottomColor: this.context.colors.trim,
    },
    label: {
      paddingHorizontal: this.context.sizes.large,
      padding: this.context.sizes.large,
      paddingBottom: this.context.sizes.small,
    },
    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: this.context.sizes.giant,
      flexWrap: "wrap",
    },
    input: {
      ...styleSheet.input,
      // alignSelf: 'stretch',
      padding: this.context.sizes.large,
    },
    iconWrapper: {
      padding: this.context.sizes.large,
    },
    buttonText: {
      flex: 1,
      textAlign: "right",
      color: this.context.colors.lightForeground,
    },
    disabledButtonWrapper: {
      backgroundColor: this.context.colors.inputBg,
    },
    disabledButtonText: {
      // opacity: 0.6,
      color: this.context.colors.placeholder,
    },
    buttonWrapper: {
      marginTop: this.context.sizes.giant,
      backgroundColor: this.context.colors.buttonBg,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: this.context.sizes.large,
    },
    selectorRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      borderWidth: 1,
      borderColor: this.context.colors.trim,
      borderRadius: this.context.sizes.small,
      maxWidth:
        (this.context.sizes.itemHeight + this.context.sizes.small * 4) * 10 + 3,
    },
    selectable: {
      width: this.context.sizes.itemHeight + this.context.sizes.small * 2,
      height: this.context.sizes.itemHeight + this.context.sizes.small * 2,
      justifyContent: "center",
      alignItems: "center",
      // backgroundColor: this.context.colors.fill,
      borderColor: this.context.colors.fill,
      borderWidth: 1,
      borderRadius: this.context.sizes.small,
      margin: this.context.sizes.small,
      padding: this.context.sizes.small,
    },
    colorDot: {
      width: this.context.sizes.itemHeight,
      height: this.context.sizes.itemHeight,
      borderRadius: this.context.sizes.itemHeight / 2,
    },
    largeColorDot: {
      width: this.context.sizes.giant,
      height: this.context.sizes.giant,
      borderRadius: this.context.sizes.giant / 2,
    },
    buttonIcon: {
      marginLeft: this.context.sizes.small,
      fontSize: this.context.sizes.itemHeight,
      color: this.context.colors.lightForeground,
    },
  });
}
